import React from 'react';
import { Target, Heart, Lightbulb, Award } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../i18n';

export const About = () => {
  const { copy } = useLanguage();
  const icons = [Target, Heart, Lightbulb, Award];
  const features = copy.about.cards.map(([title, description], index) => ({
    icon: icons[index],
    title,
    description,
  }));

  return (
    <section id="about" className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 space-y-4">
          <span className="px-4 py-2 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-sm font-medium inline-block">
            {copy.about.badge}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold">
            {copy.about.title} <span className="bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">AntZone</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {copy.about.intro}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="group hover:shadow-lg transition-all duration-300 border-2 hover:border-orange-200 dark:hover:border-orange-900"
              >
                <CardContent className="p-8 space-y-4">
                  <div className="inline-flex p-4 rounded-xl bg-gradient-to-br from-orange-100 to-red-100 dark:from-orange-900/30 dark:to-red-900/30 group-hover:scale-110 transition-transform">
                    <Icon className="h-8 w-8 text-orange-600 dark:text-orange-400" />
                  </div>
                  <h3 className="text-2xl font-bold">{feature.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 grid md:grid-cols-4 gap-8">
          <div className="text-center space-y-2 p-6 rounded-xl bg-gradient-to-br from-orange-50 to-red-50 dark:from-orange-900/20 dark:to-red-900/20 hover:scale-105 transition-transform">
            <p className="text-4xl font-bold text-orange-600">{copy.about.values[0][0]}</p>
            <p className="text-muted-foreground">{copy.about.values[0][1]}</p>
          </div>
          <div className="text-center space-y-2 p-6 rounded-xl bg-gradient-to-br from-red-50 to-yellow-50 dark:from-red-900/20 dark:to-yellow-900/20 hover:scale-105 transition-transform">
            <p className="text-4xl font-bold text-red-600">{copy.about.values[1][0]}</p>
            <p className="text-muted-foreground">{copy.about.values[1][1]}</p>
          </div>
          <div className="text-center space-y-2 p-6 rounded-xl bg-gradient-to-br from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20 hover:scale-105 transition-transform">
            <p className="text-4xl font-bold text-yellow-600">{copy.about.values[2][0]}</p>
            <p className="text-muted-foreground">{copy.about.values[2][1]}</p>
          </div>
          <div className="text-center space-y-2 p-6 rounded-xl bg-gradient-to-br from-orange-50 to-red-50 dark:from-orange-900/20 dark:to-red-900/20 hover:scale-105 transition-transform">
            <p className="text-4xl font-bold text-orange-600">{copy.about.values[3][0]}</p>
            <p className="text-muted-foreground">{copy.about.values[3][1]}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
